(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-logout.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-logout.js');
"use strict";

const {
  services,
  logger
} = svs.sportsbook.sbtech_api_impl;
const {
  userSession
} = svs.core;
const {
  session_time: sessionTime
} = svs.components;
let previousToken = null;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_logout = (_, _ref) => {
  let {
    getToken
  } = _ref;
  return () => {
    const currentToken = getToken();
    logger.info("whl.logout Session time: ".concat(sessionTime.get(), " Token: ").concat(currentToken));
    if (userSession.hasRole(userSession.roles.PLAYER)) {
      logger.info("Unexpected logout occurred! Session time: ".concat(sessionTime.get(), " Token: ").concat(currentToken));
      if (previousToken === currentToken) {
        logger.debug("whl.logout already called for token ".concat(currentToken, ". Abort fetching account balance"));
        return;
      }
      previousToken = currentToken;
      services.accountBalance((accountBalance, err) => {
        logger.info("Tried to fetch account balance ".concat(err ? 'anonymous' : 'active', ". Session time: ").concat(sessionTime.get(), " Token: ").concat(currentToken));
      }, true);
    }
  };
};

 })(window);